/******************************************************************************
 *** BgtSpcBgtFrmtMng ** 특별회계기금 예산 편성 * 수입/지출 예산 편성
*******************************************************************************/
import React from "react";
import Util from "@/js/common/Util";
import SelectBox from "@/js/common/ui/input/SelectBox";
import StyledTabs from "@/js/common/ui/StyledTabs";
import { Tab, TabList } from "react-tabs";
import { useRecoilValue } from "recoil";
import * as Atom from "@/js/common/Atom";
import BgtSpcDpstBgtFrmt from "./BgtSpcDpstBgtFrmt";
import BgtSpcExpndBgtFrmt from "./BgtSpcExpndBgtFrmt";

interface Props {
    systemCode: string;
}

const BgtSpcBgtFrmtMng = ({ systemCode }: Props) => {
    const userInfo = useRecoilValue(Atom.userInfo);

    const [upOgnzCd, setUpOgnzCd] = React.useState<string>(userInfo.upOgnzCd);
    const [ognzCd, setOgnzCd] = React.useState<string>(userInfo.ognzCd);
    const [acctYear, setAcctYear] = React.useState<string>(Util.getNowAcntgYear());

    const [callTime, setCallTime] = React.useState<Date>(new Date());
    const [tabIndex, setTabIndex] = React.useState<number>(0);

    const [itemDpstAmtSum, setItemDpstAmtSum] = React.useState<string>(""); // 수입예산 확정금액

    // 특별회계기금 타이틀
    const [systemName, setSystemName] = React.useState<string>("");

    React.useEffect(() => {
             if (systemCode === "C1") setSystemName("복지기금");
        else if (systemCode === "C2") setSystemName("자립기금");
        else if (systemCode === "C3") setSystemName("발전기금");
        else if (systemCode === "C4") setSystemName("희생자부조금");
        else if (systemCode === "C5") setSystemName("퇴직급여충당금");
        else setSystemName("");
    }, [systemCode]);

    return (
        <div className="w1200 bgcWhite p20 bdrd8 mt10 boxShadowSoft">
            <div className="mt5">
                <span className="dpBlock w100p fm-c fs25 fc2c3e50 ls1 pb10">{systemName} 예산 편성</span>
                <div className="bdt3 bdc007bff pb10" />
            </div>

            <StyledTabs selectedIndex={tabIndex} className="tabFit">
                <TabList>
                    <Tab onClick={() => setTabIndex(0)}>수입 예산</Tab>
                    <Tab onClick={() => setTabIndex(1)}>지출 예산</Tab>
                </TabList>
            </StyledTabs>

            {/* 검색조건(기존 UI 유지) */}
            <div className="bd1 bdcDDDDDD p20 mb10 bdrd6 bgcFAFAFA">
                <div className="dpFlx aiC flxWrap gap14">
                    <div className="dpFlx aiC">
                        <span className="w50 fm-c fs15 fc333333 ls1 taL">본부</span>
                        <SelectBox value={upOgnzCd}
                            width={150} height={36}
                            fontSize={14} fontFamily="fm-c" color="#333" letterSpacing={-1}
                            borderColor="#ddd" borderOnColor="#222" borderRadius={2}
                            background="#F6F6F6" paddingRight={8}
                            codeArray={Util.getUpOrgCodeArray("01")}
                            placeholder="전체"
                            onChangeFunc={(v: string) => setUpOgnzCd(v)}
                            disabled={true}
                        />
                    </div>

                    <div className="dpFlx aiC">
                        <span className="w50 fm-c fs15 fc333333 ls1 taL">지부</span>
                        <SelectBox value={ognzCd}
                            width={180} height={36}
                            fontSize={14} fontFamily="fm-c" color="#333" letterSpacing={-1}
                            borderColor="#ddd" borderOnColor="#222" borderRadius={2}
                            background="#F6F6F6" paddingRight={8}
                            codeArray={Util.getDownOrgCodeArray(upOgnzCd)}
                            placeholder="전체"
                            onChangeFunc={(v: string) => setOgnzCd(v)}
                            disabled={true}
                        />
                    </div>

                    <div className="dpFlx aiC">
                        <span className="w80 fm-c fs15 fc333333 ls1 taL">예산년도</span>
                        <SelectBox value={acctYear}
                            width={120} height={36}
                            fontSize={14} fontFamily="fm-c" color="#333" letterSpacing={-1}
                            borderColor="#ddd" borderOnColor="#222" borderRadius={2}
                            background="#fff" paddingRight={8}
                            codeArray={Util.getAcntgYearArray()}
                            placeholder="선택"
                            onChangeFunc={(v: string) => setAcctYear(v)}
                        />
                    </div>

                    {tabIndex === 1 && (
                        <div className="dpFlx aiC">
                            <span className="w120 fm-c fs15 fc333333 ls1 taL ml20">수입 예산 편성금액</span>
                            <div className="dpFlx aiC gap8 ph12 h36 bd1 bdrd2 bdcDDDDDD bgcWhite w150 jcR pr10">
                                <span className="fm-c fs15 fc007bff wsNw">
                                    {Util.comma(itemDpstAmtSum)}
                                </span>
                            </div>
                            <span className="ml5 fs14 mt10 fc666666">원</span>
                        </div>
                    )}

                </div>
            </div>

            {/* 자식 컴포넌트에 systemCode 전달 */}
            {tabIndex === 0 ? (
                <BgtSpcDpstBgtFrmt
                    ognzCd={ognzCd}
                    acctYear={acctYear}
                    callTime={callTime}
                    systemCode={systemCode}
                    setCallTime={setCallTime}
                />
            ) : (
                <BgtSpcExpndBgtFrmt
                    ognzCd={ognzCd}
                    acctYear={acctYear}
                    callTime={callTime}
                    systemCode={systemCode}
                    setCallTime={setCallTime}
                    itemDpstAmtSum={itemDpstAmtSum}     // 수입예산 편성금액
                    setItemDpstAmtSum={setItemDpstAmtSum}
                />
            )}
        </div>
    );
};

export default BgtSpcBgtFrmtMng;
